export default __webpack_public_path__ + "static/media/log-out.e32bb78f.svg";